import AreaContainer from "../AreaContainer";
import styles from './description.module.css'
import globalStyles from '../result.module.css'
import { useState } from "react";
interface Props {
    description: string;
    locationDescription: string;
    headline: string;
    keyPoints: any;
    introduction: string;
    detailed_specifications: string;
    property: boolean;
}

const Description = ({ description, locationDescription, headline, keyPoints, introduction, detailed_specifications, property = false }: Props) => {
    if (!description && !locationDescription && !headline && keyPoints.length == 0 && !introduction) return null;
    const descriptionPara = description !== null ? description.split("\n") : null;
    const [showAllDecription, setShowAllDecription] = useState(descriptionPara === null);

    return <AreaContainer area="description" style={null} extraClass={null}>
        {Array.isArray(keyPoints) && keyPoints.length > 0 &&
            <div className={!property ? `${styles.insideWrapper} ${styles.keyPointsWrapper}` : styles.keyPointsWrapper}>
                <h2 className={globalStyles.subTitleText}>Key Features</h2>
                <ul>
                    {keyPoints.map((point) => {
                        return <li key={point}><p className={`${globalStyles.mediumText} ${globalStyles.lightColorText}`}>{point}</p></li>
                    })}

                </ul>
            </div> 
        }
        {(description || locationDescription || headline || introduction) && (
            <div className={styles.DescriptionWrapper}>
                <h2 className={globalStyles.subTitleText}>Description</h2>
                <div className={!property ? styles.insideWrapper : ''}>
                    {headline && <h2 className={`${globalStyles.mediumText} ${globalStyles.lightColorText} ${globalStyles.largeLineHeight}`} >{headline}</h2>}
                    {introduction && <p className={`${globalStyles.mediumText} ${globalStyles.lightColorText} ${globalStyles.largeLineHeight}`}>{introduction}</p>}

                    {Array.isArray(descriptionPara) && descriptionPara.length > 0 && <>
                        {descriptionPara.slice(0, showAllDecription ? descriptionPara.length : 3).map((para, index) => {
                            return <p className={`${globalStyles.mediumText} ${globalStyles.lightColorText} ${globalStyles.largeLineHeight}`} key={index}>{para}</p>
                        })}
                    </>}

                    {locationDescription && showAllDecription && <p className={`${globalStyles.mediumText} ${globalStyles.lightColorText} ${globalStyles.largeLineHeight}`} dangerouslySetInnerHTML={{ __html: locationDescription }}></p>}
                    {detailed_specifications && showAllDecription && <p className={`${globalStyles.mediumText} ${globalStyles.lightColorText} ${globalStyles.largeLineHeight}`} dangerouslySetInnerHTML={{ __html: detailed_specifications }}></p>}
                    {description && (
                        <button className={`${styles.descriptionButton} ${showAllDecription ? styles.descriptionButtonUp : ''}`} onClick={() => {
                            setShowAllDecription(!showAllDecription)
                        }}>{showAllDecription ? 'Hide' : 'Read'} full description</button>
                    )}

                </div>
            </div>
        )}
    </AreaContainer>
};

export default Description;
